import StatisticsKeyValuesComponentCo2 from "./StatisticsKeyValuesComponentCo2.js";

const StatisticsCO2 = ({
  periodHistoryStart,
  periodHistoryStop,
  periodHistoryStartPrevious,
  periodHistoryStopPrevious,
  enablePreviousPeriod,
  keywordFilter,
  handleValidate,
  setHandleValidate,
}) => {
  return (
    <div className="text-blue w-full">
      <StatisticsKeyValuesComponentCo2
        periodHistoryStart={periodHistoryStart}
        periodHistoryStop={periodHistoryStop}
        periodHistoryStartPrevious={periodHistoryStartPrevious}
        periodHistoryStopPrevious={periodHistoryStopPrevious}
        enablePreviousPeriod={enablePreviousPeriod}
        keywordFilter={keywordFilter}
        handleValidate={handleValidate}
        setHandleValidate={setHandleValidate}
      />
    </div>
  );
};

export default StatisticsCO2;
